<header>
  <h2>{{ "settings.global-questions-header" | transloco }}</h2>
  <div class="config-row">
    <div
      class="ui toggle checkbox config-toggle"
      (click)="toggleConfigExportMode()"
    >
      <input type="checkbox" [ngModel]="configExportMode" />
      <label>{{ "settings.export-config-mode" | transloco }}</label>
    </div>
  </div>

  <div id="filters">
    @if (configExportMode) {
    <div class="config-date">
      <input
        type="date"
        placeholder="From date"
        [(ngModel)]="configExportDate"
        onkeydown="return false"
        [disabled]="loading"
        (change)="filterQuestionsOnDateChange()"
      />
    </div>
    } @if (configExportMode) {
    <button
      class="ui primary button background tiny config-button"
      (click)="openConfigExportConfimationModal()"
    >
      {{ "settings.download-config" | transloco }}
    </button>
    } @if (!configExportMode) {
    <div id="question-type-filter">
      <label>{{ "settings.include" | transloco }}</label>
      <select
        class="ui fluid normal multi-select dropdown"
        multiple=""
        [(ngModel)]="questionTypeFilter"
      >
        <option value="all">All</option>
        <option value="text">Text</option>
        <option value="number">Number</option>
        <option value="date picker">Date Picker</option>
        <option value="textarea">Textarea</option>
        <option value="drop down">Dropdown</option>
        <option value="people">People Picker</option>
        <option value="radio">Radio</option>
        <option value="checkbox">Checkbox</option>
        <option value="table">Table</option>
      </select>
    </div>
    } @if (!configExportMode) {
    <div id="keyword-filter">
      <div class="ui left icon fluid input">
        <i class="search icon"></i>
        <input
          type="text"
          [(ngModel)]="questionSearch"
          placeholder="{{ 'settings.search-questions' | transloco }}"
        />
      </div>
    </div>
    } @if (!configExportMode && !isProductionMode) {
    <div
      id="create-new"
      class="ui primary background button"
      [routerLink]="['new']"
    >
      {{ "settings.new-question" | transloco }}
    </div>
    }
  </div>
</header>

@if (loading) {
<div>
  <div class="ui active centered inline loader"></div>
</div>
} @if (!loading && questions?.length == 0 || (!loading &&
questionsForConfigExport?.length == 0 && configExportMode)) {
<div id="no-results">{{ "settings.no-questions-found" | transloco }}</div>
} @if (!loading && questions?.length > 0 && !configExportMode) {
<table id="list" width="100%" cellspacing="0">
  <thead>
    <tr>
      <td width="500px">{{ "settings.question" | transloco }}</td>
      <td width="200px" class="no-wrap">
        {{ "settings.type-of-field" | transloco }}
      </td>
      <td width="200px" class="no-wrap">
        {{ "settings.mandatory" | transloco }}
      </td>
      @if (!isProductionMode) {
      <td></td>
      }
    </tr>
  </thead>
  <tbody>
    @for (question of questions | keyWord:['id', 'question', 'APSRef',
    'displayTag']:questionSearch | questionType:questionTypeFilter; track
    question) {
    <tr [routerLink]="[question?.id]">
      <td>
        @if (showQuestionId) {
        <span>{{ question?.id }}.</span>
        } {{ question?.question }}
      </td>
      <td>{{ question?.questionType }}</td>
      <td>{{ question?.mandatory ? "Yes" : "No" }}</td>
      @if (!isProductionMode) {
      <td align="right" class="btn">{{ "settings.edit" | transloco }}</td>
      }
    </tr>
    }
  </tbody>
</table>
} @if (!loading && questionsForConfigExport?.length > 0 && configExportMode) {
<table id="list" width="100%" cellspacing="0">
  <thead>
    <tr>
      <td>
        <div class="ui checkbox">
          <input
            type="checkbox"
            [(ngModel)]="entireListSelected"
            (change)="entireListSelection()"
          /><label>&nbsp;</label>
        </div>
      </td>
      <td width="500px">{{ "settings.question" | transloco }}</td>
      <td width="200px" class="no-wrap">
        {{ "settings.type-of-field" | transloco }}
      </td>
      <td width="200px" class="no-wrap">
        {{ "settings.mandatory" | transloco }}
      </td>
      @if (config.featureFlags.aps) {
      <td width="200px" class="no-wrap">
        {{ "settings.aps-reference" | transloco }}
      </td>
      }
      <td>{{ "settings.created" | transloco }}</td>
      <td>{{ "settings.updated" | transloco }}</td>
      <td>{{ "settings.calc-plan-updated" | transloco }}</td>
    </tr>
  </thead>
  <tbody>
    @for (question of questionsForConfigExport; track question) {
    <tr>
      <td>
        <div class="ui checkbox">
          <input
            type="checkbox"
            [(ngModel)]="question.selected"
            (change)="listSelection()"
          /><label>&nbsp;</label>
        </div>
      </td>
      <td>
        @if (showQuestionId) {
        <span>{{ question?.id }}.</span>
        } {{ question?.question }}
      </td>
      <td>{{ question?.questionType }}</td>
      <td>{{ question?.mandatory ? "Yes" : "No" }}</td>
      @if (config.featureFlags.aps) {
      <td
        textTruncate
        [text]="question?.APSRef"
        [length]="60"
        title="{{ question?.APSRef }}"
      ></td>
      }
      <td>{{ question?.displayCreatedAt }}</td>
      <td>{{ question?.displayUpdatedAt }}</td>
      <td>{{ question?.name }} {{ question?.calcUpdatedAt }}</td>
    </tr>
    }
  </tbody>
</table>
}

<div #configExportConfimationModal class="ui modal config-export-modal">
  <div class="icon modal-close close"></div>
  <p>
    {{ "settings.please-confirm-the-selected-config-to-export" | transloco }}
  </p>
  <table class="ui striped table">
    <thead>
      <tr>
        <th>{{ "settings.question" | transloco }}</th>
        <th>{{ "settings.updated" | transloco }}</th>
      </tr>
    </thead>
    <tbody>
      @for (question of selectedQuestions; track question) {
      <tr>
        <td>
          @if (showQuestionId) {
          <span>{{ question?.id }}.</span>
          } {{ question?.question }}
        </td>
        <td>{{ question.displayUpdatedAt }}</td>
      </tr>
      }
    </tbody>
  </table>
  @if (!selectedQuestions.length) {
  <p>{{ "settings.nothing-selected" | transloco }}</p>
  }
  <button
    class="ui primary button background tiny config-button"
    [ngClass]="{ disabled: !selectedQuestions.length }"
    (click)="downloadConfig()"
  >
    {{ "settings.download" | transloco }}
  </button>
</div>
